import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginGuard } from '../auth/loginGuard';
import { AdminLayoutComponent } from './layout/admin-layout.component';
import { SupportBugsComponent } from './support-bugs/support-bugs.component';
import { ManagedProfessionalsComponent } from './managed-professionals/managed-professionals.component';
import { HealthOrganizationStatusComponent } from './health-organization-status/health-organization-status.component';
import { UserImpersonateSelectionComponent } from './user-impersonate-selection/user-impersonate-selection.component';
import { ManageTemplateFormsComponent } from './manage-template-forms/manage-template-forms.component';
import { FormDocumentDetailsComponent } from '../physician/formdocs/form-document-details/form-document-details.component';
import { SendMessageComponent } from '../physician/chat/send-message/send-message.component';
import { SendMultipleMessagesComponent } from '../physician/chat/send-multiple-messages/send-multiple-messages.component';
import { NewDashboardComponent } from '../physician/dashboard/new-dashboard/new-dashboard.component';
import { UserActivityComponent } from './user-activity/user-activity.component';
import { MarketplaceActivityComponent } from './marketplace-activity/marketplace-activity.component';
import { NpiDataPullComponent } from './npi-data-pull/npi-data-pull.component';
import { EmployerStatusComponent } from './employer-status/employer-status.component';
import { AgencyStatusComponent } from './agency-status/agency-status.component';

const routes: Routes = [

  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: [
      { path: '', redirectTo: 'newDashboard', pathMatch: 'full' },
      { path: 'supportbugs', component: SupportBugsComponent, canActivate: [LoginGuard] },
      { path: 'professionals', component: ManagedProfessionalsComponent, canActivate: [LoginGuard] },
      { path: 'healthOrganizations', component: HealthOrganizationStatusComponent, canActivate: [LoginGuard] },
      { path: 'employer', component: EmployerStatusComponent, canActivate: [LoginGuard] },
      { path: 'agency', component: AgencyStatusComponent, canActivate: [LoginGuard] },
      { path: 'impersonateUser', component: UserImpersonateSelectionComponent, canActivate : [LoginGuard]},
      { path: 'manageTemplateForms', component: ManageTemplateFormsComponent, canActivate: [LoginGuard]},
      { path: 'manageTemplateForms/details/:id', component: FormDocumentDetailsComponent, canActivate: [LoginGuard] },
      { path: 'sendMessage', component: SendMessageComponent, canActivate: [LoginGuard] },
      { path: 'sendMultipleMessage', component: SendMultipleMessagesComponent, canActivate: [LoginGuard] },
      { path: 'newDashboard', component: NewDashboardComponent, canActivate: [LoginGuard] },
      { path: 'useractivity', component: UserActivityComponent, canActivate: [LoginGuard] },
      { path: 'marketplaceactivity', component: MarketplaceActivityComponent, canActivate: [LoginGuard] },
      { path: 'npidatapull', component: NpiDataPullComponent, canActivate: [LoginGuard] },
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [ReactiveFormsModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
